<template>
  <div id="app" class="sa-container">
    <router-view></router-view>
    <!-- video call ringer -->
    <ringer v-if="isRinging" />
    <!-- video call participant frames -->
    <video-call-view v-if="inCall" />

    <div v-if="loading" class="sa-loader-bg">
      <img src="/static/img/loader.svg" alt="loader" class="sa-loader" />
    </div>
  </div>
</template>
<script>
const Ringer = () =>
  import(/* webpackChunkName: "ringer" */ "./components/chat/Ringer.vue");
const VideoCallView = () =>
  import(/* webpackChunkName: "video-view" */ "./components/chat/VideoCallView.vue");
import { ConnectionStatus } from "./util/common";
import uniqid from "uniqid";
import io from "socket.io-client";
import { SOCKETHUB_ENDPOINT } from "./config";
import { bus } from "./main";
import i18n from "./i18n";

export default {
  name: "App",
  components: {
    Ringer,
    VideoCallView,
  },
  watch: {},
  data() {
    return {
      socket: null,
      socketId: null,
      did: uniqid()
    };
  },
  computed: {
    isRinging() {
      return this.$store.getters["videocall/isRinging"];
    },
    inCall() {
      let callConnectionStatus = this.$store.getters["videocall/inCallStatus"];
      if(callConnectionStatus != 'disconnected'){
        return (
          callConnectionStatus === ConnectionStatus.CONNECTED ||
          callConnectionStatus === ConnectionStatus.IN_PROGRESS
        );
      }else{
        return false
      }
    },
    notificationPayload() {
      return this.$store.getters["common/getNotificationPayload"];
    },
    loading() {
      return this.$store.getters["UI/loading"];
    },
  },
  mounted() {
    bus.$on('SOCKET_INIT', this.socketInit)
    bus.$on("DECLINE_CALL", this.declineCall);
    bus.$on("ACCEPT_CALL", this.acceptCall);
  },
  methods: {
    socketInit(userId) {
      console.log('calling socket init');
      console.log('userId : ', userId);
      let did = this.did;
      this.socket = io(SOCKETHUB_ENDPOINT, {
        query: `uid=${userId}&did=${did}`,
      });
      if (this.socket) {
        this.socket.on("connect", this.socketConnect);
        this.socket.on("disconnect", this.socketDisconnected);
      }
    },
    async socketConnect() {
      console.log("Socket Connected...");
      this.socketId = this.socket.id;
      // setting socket id once connected
      const socketId = this.$store.getters["socket/getSocketId"];
      if (!socketId) {
        this.$store.dispatch("socket/SET_SOCKET_ID", this.socketId);
        this.socket.on("INCOMING_MESSAGE", this.incomingMessage);
        this.socket.on("VIDEO_CALL", (payload) => {
          const callStatus = this.$store.getters["videocall/callStatus"];
          if(callStatus==ConnectionStatus.DISCONNECTED) {
            console.log('incoming call payload : ', payload)
            this.$store.dispatch("videocall/INCOMING_CALL", {
              isRinging: true,
              data: payload,
            });
          }
        });
        this.socket.on("CALL_REJECTED", async () => {
            await this.$store.dispatch('videocall/UPDATE_CALL_STATUS', ConnectionStatus.DISCONNECTED);
            this.$store.dispatch("videocall/INCOMING_CALL", { isRinging: false });
        });
      }
    },
    socketDisconnected() {
      console.log("Socket Disconnected...");
    },
    incomingMessage(payload) {
      let notificationPayload = {
        data: {
          type: "chat",
          id: payload.chatroom_id,
          utid: payload.utid || "",
          status: payload.status || "",
          ...payload,
        },
        notification: {
          title: i18n.t("notimsg"),
          body: i18n.t("fromapointid") + "" + `${payload.chatroom_id}`,
        },
      };
      this.$store.dispatch(
        "common/SET_NOTIFICATION_PAYLOAD",
        notificationPayload
      );
      let activeChatroom;
      if (this.inCall) {
        let callPayload = this.$store.getters[
          "videocall/getIncomingCallPayload"
        ];
        activeChatroom = callPayload.roomName;
      } else {
        activeChatroom = this.$store.getters["appointment/getActiveChatroom"];
      }
      // check if user in call and same chatroom
      const callStatus = this.$store.getters["videocall/callStatus"];
      // TODO: need to handle notificatoin from different chatroom / appointment.
      if (
        callStatus == ConnectionStatus.CONNECTED &&
        activeChatroom == payload.chatroom_id
      ) {
        this.$store.dispatch("socket/SET_NEW_MSG_FLAG", true);
        bus.$emit("CHAT_NOTIFICATION");
      } else if (activeChatroom && activeChatroom == payload.chatroom_id) {
        // check if user in same chat room
        bus.$emit("CHAT_NOTIFICATION");
      } else {
        this.$store.dispatch("common/SHOW_NOTIFICATION", true);
      }
      // hide notification alert after 5 seconds
      setTimeout(() => {
        this.$store.dispatch("common/SHOW_NOTIFICATION", false);
      }, 5000);
    },
    async acceptCall() {
      let token = await this.$store.getters["user/getToken"];
      let incomingPayload = await this.$store.getters[
        "videocall/getIncomingCallPayload"
      ];
      this.$store.dispatch("videocall/INCOMING_CALL", {
        isRinging: false,
        data: incomingPayload,
      });
      this.socket.emit(
        "ACCEPT_CALL",
        JSON.stringify({
          did: this.did,
          headerToken: token,
          dsid: incomingPayload.sid,
          roomName: incomingPayload.roomName,
        })
      );
      this.$store.dispatch(
        "videocall/UPDATE_CALL_STATUS",
        ConnectionStatus.CONNECTED
      );
    },
    async declineCall() {
      try {
        let token = await this.$store.getters["user/getToken"];
        let incomingPayload = await this.$store.getters[
          "videocall/getIncomingCallPayload"
        ];
        console.log("checking incoming Payload : ", incomingPayload);
        if(incomingPayload) {
          this.socket.emit(
            "REJECT_CALL",
            JSON.stringify({
              did: this.did,
              headerToken: token,
              dsid: incomingPayload.sid,
            })
          );
        }
        this.$store.dispatch("videocall/INCOMING_CALL", { isRinging: false });
      } catch (error) {
        console.log("error : ", error);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue